import {Locales} from '@netx/core-next/locales/utils/Locales';
import {AssetGalleryLayout} from './constants';

export const AssetGalleryActionLabel = Locales((i18n) => ({
	ADD_TO_CART: i18n('i18n.addAllToSelection'),
	SELECT_ALL: i18n('i18n.selectAll'),
}));

export const AssetGalleryLabel = Locales((i18n) => ({
	FILTER_AND_SORT: i18n('i18n.filterAndSort'),
	VIEW_AND_SORT: i18n('i18n.viewAndSort'),
}));

export const AssetGalleryLayoutLabel = Locales((i18n) => ({
	[AssetGalleryLayout.CARD]: i18n('i18n.card'),
	[AssetGalleryLayout.CURATOR]: i18n('i18n.curator'),
	[AssetGalleryLayout.GRID]: i18n('i18n.mosaic'),
	[AssetGalleryLayout.LIST]: i18n('i18n.list'),
}));

export const AssetGalleryTitle = Locales((i18n) => ({
	ADVANCED: i18n('i18n.advancedSearch'),
	CATEGORY: i18n('i18n.category'),
	ATTRIBUTE_HISTORY: i18n('i18n.attributeHistorySearch'),
	CURRENT_CART: i18n('i18n.currentCart'),
	EXPIRATION: i18n('i18n.expiringAssets'),
	IDENITIFIED_PEOPLE: i18n('i18n.people'),
	AI: i18n('i18n.ai'),
	SAVED_CART: i18n('i18n.savedSelection'),
	SAVED_SEARCH: i18n('i18n.savedSearch'),
	VISUAL_ASSET_SEARCH: i18n('i18n.visualAssetSearch'),
	VISUAL_COLOR_SEARCH: i18n('i18n.visualColorSearch'),
	LAYOUT: i18n('i18n.layout'),
	COUNT: (count: number) => i18n('i18n.nAssets', {count}),
}));

export const AssetGalleryMessage = Locales((i18n) => ({
	NO_RECORDS: i18n('i18n.noAssetsFound'),
}));
